import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { LocalizationPipe } from '@abp/ng.core';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { CrudService } from 'src/core/services/crud/crud.service';
import { ToasterService } from 'src/core/services/toaster/toaster.service';
import { FormActionsComponent } from 'src/core/forms/form-actions/form-actions.component';
import { SkillDto } from 'src/core/models/skill/skill.dto';

@Component({
  selector: 'app-skill-form-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReactiveFormsModule, LocalizationPipe, DialogModule, InputTextModule, FormActionsComponent],
  templateUrl: './skill-form-dialog.component.html',
})
export class SkillFormDialogComponent implements OnChanges {
  private readonly fb = inject(FormBuilder);
  private readonly crudService = inject(CrudService);
  private readonly toasterService = inject(ToasterService);

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter<void>();

  form: FormGroup = this.fb.group({
    name: this.fb.control('', [Validators.required, Validators.maxLength(100)]),
  });

  isSubmitting = false;

  ngOnChanges(): void {
    if (this.visible) {
      this.form.reset({ name: '' });
    }
  }

  onHide(): void {
    this.visibleChange.emit(false);
  }

  onCancel(): void {
    this.visibleChange.emit(false);
  }

  onSave(): void {
    if (this.form.invalid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    const name = String(this.form.value.name ?? '').trim();
    const payload: Partial<SkillDto> = {
      name,
      isActive: true,
    };

    this.crudService
      .insertWithoutId(SkillDto, payload)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: () => {
          this.toasterService.success('Settings::WorkEnvironment:Skills:SaveSuccess');
          this.saved.emit();
        },
        error: () => {
        },
      });
  }
}
